import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { live_groups_vdo } from '../../assets'
import { Link } from 'react-router-dom'

const OverviewListShimmer = ({ count = 5 }) => {
    return (
        <>
            <div className="cards_container">
                {Array(count).fill().map((_, ind) => (
                    <div key={ind} className="_card" >
                        <div className="_cards_header" style={{ alignItems: "center" }}>
                            <Skeleton circle height={50} width={50} />
                            <div className='w-75'>
                                <Skeleton width="50%" />
                                <Skeleton width="70%" />
                            </div>
                            <Skeleton width={10} height={20} />
                        </div>
                        <div className="card_image">
                            <Skeleton width='100%' height={160} />
                        </div>

                        <div className="card_content">
                            <Skeleton width={160} height={20} />
                        </div>

                        <div className="card_footer">
                            <div style={{ width: "32%" }}>
                                <Skeleton width="100%" height={20} />
                            </div>
                            <div style={{ width: "32%" }}>
                                <Skeleton width="100%" height={20} />
                            </div>
                            <div style={{ width: "32%" }}>
                                <Skeleton width="100%" height={20} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>

        </>
    )
}

export default OverviewListShimmer

export const LiveShimmer = () => {
    return (
        <div className="program-item">
            <Skeleton className='program-image' />
            <div className="program-details w-75">
                <h3>
                    <Skeleton width="30%" />
                </h3>
                <p>
                    <Skeleton width="60%" />
                </p>
            </div>
            <p className='program-price w-25 text-end' >
                <Skeleton circle={true} height={35} width={35} />
            </p>
        </div>
    )
}